import { SET_THEME, SET_LANGUAGE } from './app-constants';

export type SetThemeType = {
  type: typeof SET_THEME;
  payload: string;
};
export function setTheme(value: string): SetThemeType {
  return {
    type: SET_THEME,
    payload: value
  };
}
export type SetLanguageType = {
  type: typeof SET_LANGUAGE;
  payload: string;
};
export function setLanguage(value: string): SetLanguageType {
  return {
    type: SET_LANGUAGE,
    payload: value
  };
}
